import React from "react";

import styles from "../../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "@tools/EnvironmentStorage";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { Label, Button, Drawer, Loading, Input } from "@components";
import { FileReaderInput } from "shared/components/FileReaderInput";
import { IntegrationsAPI } from "providers/IntegrationsAPI";

export default class ApplePayAddDomainDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: false,
      loading: false,
      domain: null,
      file: null,
    };
  }

  componentDidMount() {
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { domain, file } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const domainResponse = await IntegrationsAPI.upsertApplePayDomain(
        environmentId,
        {
          domain,
          file: {
            name: file.name,
            data: file.content,
          },
        }
      );

      this.setState({ loading: false });

      if (domainResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível cadastrar o domínio - ${
            domainResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  setFile(file) {
    this.setState({
      file: file,
    });
  }

  render() {
    const { loading, loadingPage, domain, file } = this.state;
    const { onClose } = this.props;

    const isValid = !!domain && !!file?.content;

    return (
      <Drawer
        visible
        onClose={onClose}
        closeInFade
        title={"Apple Pay - Domínio"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Salvar
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Input
              design="two"
              className="mb-20"
              floatLabel="Domínio"
              value={domain}
              onChange={(e) =>
                this.setState({ domain: String(e.target.value || "").trim() })
              }
            />

            <Label>Selecione o arquivo</Label>
            <FileReaderInput
              file={file}
              acceptedTypes={[".txt"]}
              onFileLoaded={(file) => {
                console.log(file);
                this.setFile(file);
              }}
            />
          </div>
        )}
      </Drawer>
    );
  }
}
